var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.8,7.7c4,0,7.2,3.3,7.2,7.3c0,4-3.3,7.2-7.3,7.2s-7.2-3.3-7.2-7.3c0-1.9,0.8-3.8,2.1-5.1C18,8.4,19.9,7.7,21.8,7.7  M21.8,6.7c-4.5,0-8.2,3.7-8.2,8.2s3.7,8.2,8.2,8.2s8.2-3.7,8.2-8.2S26.3,6.7,21.8,6.7L21.8,6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4,30H5.3C2.4,30,0,27.7,0,24.8V5.7L5.8,0h11.6c2.8,0,5.1,2.2,5.3,4.9l0,0.5l-0.5,0c-0.2,0-0.3,0-0.4,0V5h0 c-0.1-2.3-2-4-4.3-4H6.2L0.9,6.1v18.7c0,2.3,1.9,4.2,4.3,4.2h12.1c2.4,0,4.3-1.9,4.3-4.2h0v-0.5c0.1,0,0.3,0,0.4,0l0.5,0l0,0.5 c0,1.4-0.6,2.7-1.6,3.6C20.1,29.5,18.8,30,17.4,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,18.1l0.8-0.7c0.8,0.6,1.9,1,3.1,1c1.5,0,2.3-0.5,2.3-1.3c0-0.9-0.8-1.1-1.9-1.5l-1.5-0.5c-1.1-0.3-2.3-0.9-2.3-2.1 c0-1.2,1.5-2.1,3.5-2.1c1.3,0,2.5,0.4,3.3,1l-0.7,0.7c-0.7-0.5-1.5-0.8-2.6-0.8c-1.2,0-2.1,0.4-2.1,1.2c0,0.8,1,1.1,1.9,1.3 l1.5,0.5c1.3,0.4,2.4,1,2.4,2.2c0,1.3-1.4,2.3-3.8,2.3C20.3,19.3,19,18.8,18,18.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.7,8.1 4.7,8.1 4.7,7.2 7.7,7.2 7.7,0.6 8.7,0.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.6,
    y: 14.4,
    width: 7.2,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.6,
    y: 18.3,
    width: 7.8,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.7,
    y: 22.1,
    width: 10.7,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.3,
    y: 9.8,
    width: 1,
    height: 10.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoices);
export default __webpack_public_path__ + "static/media/invoices.19cfe8007723b453c85e251d80011899.svg";
export { ForwardRef as ReactComponent };